<template>
  <el-table
    ref="tableRef"
    :data="tableData"
    v-loading="listLoading"
    border
    fit
    highlight-current-row
    style="width:100%"
    :default-sort="{prop: sort, order: order === 'desc'? 'descending':'ascending'}"
    @sort-change="handleOrder"
    @selection-change="handleSelection"
  >
    <el-table-column
      v-if="haveSelection"
      type="selection"
    />
    <el-table-column
      :key="'t-column'+index"
      v-for="item, index in columnStruct"
      :prop="item.prop"
      :label="t(item.label)"
      :sortable="item.sortable"
      :formatter="item.formatter"
    >
      <template
        v-if="item.link || item.img || item.base64"
        #default="{row}"
      >
        <el-link
          v-if="item.link"
          :href="row[item.prop]"
          target="_blank"
          type="primary"
        >
          {{ row[item.prop] }}
        </el-link>
        <img
          v-if="item.img"
          :src="row[item.img]"
          style="object-fit: contain;max-width:200px; max-height: 100px"
        >
        <img
          v-if="item.base64"
          :src="'data:image/jpg;base64,' + row[item.base64]"
          style="object-fit: contain;max-width:200px; max-height: 100px"
        >
      </template>
    </el-table-column>
    <el-table-column
      v-if="hadOperate"
      :label="t('common.operate')"
      :width="operateColumnWidth"
    >
      <template #default="{row}">
        <slot
          :row="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { ElTable } from 'element-plus'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    sort: {
      type: String,
      required: false,
      default: 'createTime'
    },
    order: {
      type: String,
      required: false,
      default: 'desc'
    },
    haveSelection: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['handleOrder', 'handleSelection'],
  setup(props, context) {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const handleSelection = (item: any[]) => {
      context.emit('handleSelection', item.map(i => i.id))
    }
    const handleOrder = (column: any) => {
      context.emit('handleOrder', column)
    }
    return { t, tableRef, handleSelection, handleOrder }
  }
})
</script>
